import React from 'react';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import { cleanseDecimal } from 'src/ui/util';
import propTypes from 'prop-types';
import { UiInputAdapter, UiFieldset } from 'src/ui';

export function PricingForm({ form }) {
  return (
    <>
      <UiFieldset title="PIN Debit IC+ PassThrough" isFirst>
        <Columns>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="pricingFormat"
              id="pricingFormat"
              label="Pricing Format"
              disabled
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="processingType"
              id="processingType"
              label="Processing Type"
              disabled
            />
          </Column>
        </Columns>
      </UiFieldset>

      <UiFieldset title="Additional Fees" isFirst>
        <Columns>
          <Column isSize="1/3">
            <Field
              component={UiInputAdapter}
              name="pinBasedDebitRate"
              id="pinBasedDebitRate"
              label="PIN Based Debit Rate %"
              onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
            />
            <Field
              component={UiInputAdapter}
              name="chargeBackFee"
              id="chargeBackFee"
              label="Chargeback Fee $"
              disabled
            />
            <Field
              component={UiInputAdapter}
              name="salesTrxFee"
              id="salesTrxFee"
              label="Sales Trx Fee $"
              onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
            />
            <Field
              component={UiInputAdapter}
              name="monthlyMinimumFee"
              id="monthlyMinimumFeessName"
              label="Monthly Minimum Fee $"
              disabled
            />
            <Field
              component={UiInputAdapter}
              name="achRejectFee"
              id="achRejectFee"
              label="ACH Reject Fee $"
              disabled
            />
          </Column>
          <Column isSize="1/3">
            <Field
              component={UiInputAdapter}
              name="pciMonthlyProgramFee"
              id="pciMonthlyProgramFee"
              label="PCI Monthly Program Fee $"
              disabled
            />
            <Field
              component={UiInputAdapter}
              name="retrievalFee"
              id="retrievalFee"
              label="Retrieval Fee $"
              disabled
            />
            <Field
              component={UiInputAdapter}
              name="returnFee"
              id="returnFee"
              label="Return Fee $"
              disabled
            />
            <Field
              component={UiInputAdapter}
              name="batchCloseFee"
              id="batchCloseFee"
              label="Batch Close Fee $"
              disabled
            />
          </Column>
          <Column isSize="1/3">
            <Field
              component={UiInputAdapter}
              name="terminalIdFee"
              id="terminalIdFee"
              label="Terminal ID Fee $"
              disabled
            />
            <Field
              component={UiInputAdapter}
              name="monthlyStatementFee"
              id="monthlyStatementFee"
              label="Monthly Statement Fee $"
              disabled
            />
            <Field
              component={UiInputAdapter}
              name="onlinePortalFee"
              id="onlinePortalFee"
              label="Online Portal Fee $"
              disabled
            />
            <Field
              component={UiInputAdapter}
              name="pciNonComplianceFee"
              id="pciNonComplianceFee"
              label="PCI Non-Compliance Fee $"
              disabled
            />
          </Column>
        </Columns>
      </UiFieldset>
    </>
  );
}

PricingForm.propTypes = {
  form: propTypes.object.isRequired,
};
